import { Alert } from "@mui/material";
import Snackbar from "@mui/material/Snackbar";

const Toast = ({ open, message, severity, onClose }) => {
    return (
        <Snackbar
            open={open}
            autoHideDuration={4000} // Adjust time as needed
            onClose={onClose}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            TransitionProps={{ timeout: 500 }} // Smooth transition for fade-in and fade-out
        >
            <Alert
                onClose={onClose}
                severity={severity} // 'success', 'error', 'info', or 'warning'
                sx={{
                    width: "100%",
                    borderRadius: "12px", // Rounded corners for a modern look
                    padding: "10px", // Spacious padding
                    fontSize: "18px", // Slightly larger font size for readability
                    boxShadow: 6, // Deeper shadow for floating effect
                    backgroundColor:
                        severity === "success"
                            ? "#369D00" // White with 80% opacity for success
                            : severity === "error"
                                ? "rgb(207, 18, 18)" // Semi-transparent red for error
                                : severity === "info"
                                    ? "#EFE4CB" // Semi-transparent blue for info
                                    : "#FFC501", // Semi-transparent orange for warning
                    color:
                        severity === "success"
                            ? "#ffffff" // Green text for success
                            : severity === "error"
                                ? "#ffffff" // Red text for error
                                : severity === "info"
                                    ? "#4C2F2C" // Blue text for info
                                    : "#4C2F2C", // Orange text for warning
                    "& .MuiAlert-message": {
                        fontWeight: "600", // Bold message for emphasis
                        fontFamily: "'Roboto', sans-serif", // Modern font family
                    },
                    "& .MuiAlert-icon": {
                        color: ['warning', 'info'].includes(severity) ? "#4C2F2C" : "#fff", // Icon color to match the theme
                        fontSize: "24px", // Icon size
                    },
                    transition: "transform 0.3s ease-in-out, opacity 0.3s ease-in-out", // Smooth animation for transitions
                    transform: open ? "translateY(0)" : "translateY(10px)", // Animation effect
                }}
            >
                {message}
            </Alert>
        </Snackbar>
    );
};

export default Toast;
